import { delay } from "common/promises";
export async function run({ elements: { background, button, black, title, message, hand }, sound, pixiContext, }) {
    black.sprite.visible = true;
    message.sprite.visible = true;
    background.sprite.visible = true;
    background.sprite.play();
    hand.sprite.visible = true;
    const soundPromise = sound.awaitPlay("opening").then(async () => {
        sound.playLoop("background");
        sound.playLoop("heartbeat");
        await sound.awaitPlay("speaking0");
    });
    await pixiContext.animate({
        start: 1,
        destination: 0,
        durationMS: 1000,
        setter: (value) => (black.sprite.alpha = value),
    });
    title.sprite.alpha = 1;
    title.sprite.visible = true;
    title.sprite.play();
    await delay(1000);
    button.sprite.alpha = 0;
    button.sprite.visible = true;
    button.animate();
    await Promise.all([
        buttonFadeIn(pixiContext, button),
        titleFadeOut(pixiContext, title),
        soundPromise,
    ]);
}
async function titleFadeOut(pixiContext, title) {
    await pixiContext.animate({
        start: 1,
        destination: 0,
        durationMS: 500,
        setter: (value) => {
            title.sprite.alpha = value;
        },
    });
}
async function buttonFadeIn(pixiContext, button) {
    await pixiContext.animate({
        start: 0,
        destination: 1,
        durationMS: 1000,
        setter: (value) => {
            button.sprite.alpha = value;
        },
    });
}
//# sourceMappingURL=loadingAnimation.js.map